import React, { PureComponent } from 'react';
import { Card, Image, Icon, Popup, Grid } from 'semantic-ui-react';
import OptionalContent from './OptionalContent';
import RequirementsContent from './RequirementsContent';
import EquipmentContent from './EquipmentContent';
import RuneContent from './runes/RuneContent';
import SlotContent from './SlotContent';
import ValueElement from '../../../common/ValueElement';
import {getRarityColor} from '../../../common/RarirtyColorFactory';

export default class ItemSummaryCard extends PureComponent {

    render() {
        const { item } = this.props;

        const rarityColor = getRarityColor(item.Rarity);

        const soulboundElement = (item.SoulboundTrigger) ?
            <Card.Meta>
                {item.SoulboundTrigger.replace(/([A-Z])/g, ' $1').trim()}
            </Card.Meta> :
            null;

        return (
            <Card>
                <Card.Content>
                    <Image rounded={true} size='mini' floated='right' src={`\\images\\${item.Icon}.png`} bordered style={{borderColor: rarityColor}}/>
                    <Card.Header>
                        <span style={{color: rarityColor}}>{item.Name.English}</span>
                    </Card.Header>
                    <Card.Meta>
                        {item.Category}
                    </Card.Meta>
                    {soulboundElement}
                    <SlotContent equipment={item.Equipment} />
                </Card.Content>
                <OptionalContent property={item.Description}>
                    {item.Description ? item.Description.English : null}
                </OptionalContent>
                <OptionalContent property={item.FlavorText}>
                    <small>{item.FlavorText ? item.FlavorText.English : null}</small>
                </OptionalContent>
                <RuneContent rune={item.Rune} />
                <EquipmentContent equipment={item.Equipment} />
                <RequirementsContent requirements={item.Requirements} />
                <Card.Content extra>
                    <Grid>
                        <Grid.Column width={1}>
                            <Popup
                                trigger={<Icon name="computer" />}
                                content={`AddonType ${item.AddonType}`}
                                on="hover"
                                hoverable={true}
                            />
                        </Grid.Column>
                        <Grid.Column textAlign="right" width={14}>
                            <ValueElement value={item.Value}/>
                        </Grid.Column>
                    </Grid>
                </Card.Content>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/ItemSummaryCard.jsx